<template>
  <div class="clearfix navy-box">
    <!-- <div class="logo"><img src="@/assets/images/logo.png"></div>
        <div class="clearfix navy">
            <ul class="left clearfix navy-list">
                <li><a href="https://www.renogy-dchome.com/pc/#/" class="font-bolder">Forum</a></li>
                <li><a href="https://www.renogy.com/?ctk=5c6fdc87-b5e7-4833-8be9-3db5c6928206" class="font-bolder">Store</a></li>
                <li><a href="javascript:;" class="font-bolder active">Calculator</a></li>
            </ul>
        </div> -->
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped type="text/css">
// 头部菜单栏样式
.navy-box {
  padding: 0 50px;
  height: 0px;
  background-color: transparent;
  .logo {
    padding-top: 12px;
    height: 55px;
    margin-right: 70px;
    float: left;
    img {
      height: 30px;
    }
  }
  .navy {
    float: left;
    .navy-list li {
      float: left;
      a {
        display: block;
        height: 55px;
        line-height: 55px;
        color: #959798;
        font-size: 15px;
        font-weight: bold;
        // padding: 0 30px;
        margin: 0 30px;
        position: relative;
        &.active {
          color: #333;
        }
        &.active::after {
          content: "";
          position: absolute;
          bottom: 11px;
          left: 50%;
          display: block;
          width: 100%;
          height: 2px;
          border-radius: 3px;
          background: #3dc6ea;
          transform: translateX(-50%);
        }
        // &:hover {
        //     color: unset;
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navyBar/NavyBar.vue